<template>
    <transition name="fade-out">
        <div class="light-box" v-show="status">
            <div class="content">
                <img :src="pic" @click="close">
            </div>
            <b class="close" @click="close">×</b>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'LightBox',
    data () {
        return {
            pic: '',
            status: false
        }
    },
    methods: {
        show (pic) {
            this.pic = pic
            this.status = true
        },
        close () {
            this.status = false
            this.pic = ''
        }
    }
}
</script>

<style lang="scss">
.light-box {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 0;
    font-weight: 300;
    background-color: rgba(0,0,0,0.36);
    z-index: 21;
    .content {
        max-height: 100%;
        overflow-y: scroll;
        top: 50%;
        right: -17px;
        left: 0;
        position: absolute;
        text-align: center;
        font-size: 0;
        transform: translate3d(0,-50%,0);
        img {
            max-width: 100%;
            cursor: pointer;
        }
    }
    .close {
        display: block;
        width: 80px;
        height: 80px;
        position: absolute;
        top: 0;
        right: 0;
        background: rgba(64, 158, 255, 0.94) url(../assets/img/icon-close.png) center no-repeat;
        background-size: 60%;
        cursor: pointer;
    }
}
</style>
